export default {
    SETCOMPANIES(state, companies) {
        state.companiesList = [...companies];
    },
    SETNUMBEROFRESULTS(state, numberOfResults) {
        state.numberOfResults = numberOfResults;
    },
    SET_DEPARTMENT(state, departments) {
        state.departments = [...departments];
    },
}